import { useMemo, useState } from 'react';

import { DASHBOARD_DATE_OPTIONS } from '../constants';
import { formatCustomDateLabel, formatDateForDuration } from '../utils';

const useDashboardDateRange = () => {
  const [selectedDate, setSelectedDate] = useState(DASHBOARD_DATE_OPTIONS[4]);
  const [customDateRange, setCustomDateRange] = useState([null, null]);
  const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);

  const dateOptions = useMemo(() => {
    const customOption = {
      id: 'custom-date',
      title: 'Custom date',
      func: () => {
        setCustomDateRange([null, null]);
        setIsCustomDateOpen(true);
      },
    };

    return selectedDate.duration
      ? [selectedDate, ...DASHBOARD_DATE_OPTIONS, customOption]
      : [...DASHBOARD_DATE_OPTIONS, customOption];
  }, [selectedDate]);

  const applyCustomDate = ([startDate, endDate]) => {
    if (!startDate || !endDate) return;

    setSelectedDate({
      id: 'selected-custom-date',
      title: formatCustomDateLabel(startDate, endDate),
      duration: `custom ${formatDateForDuration(startDate)} ${formatDateForDuration(endDate)}`,
    });
    setIsCustomDateOpen(false);
  };

  const dashboardDuration = selectedDate.duration || selectedDate.title.toLowerCase();

  return {
    selectedDate,
    setSelectedDate,
    customDateRange,
    setCustomDateRange,
    isCustomDateOpen,
    setIsCustomDateOpen,
    dateOptions,
    applyCustomDate,
    dashboardDuration,
  };
};

export default useDashboardDateRange;
